/**
 * useUserPrimaryDomain — hämta primary-hostname för en given org.
 *
 * Används av ManagerRoute för cross-hostname-redirect (F-3): om en admin
 * landat på fel hostname (t.ex. demo.boply.app) men är admin för en annan
 * org (t.ex. AP Nacka), skicka dem till sin egen primary domain.
 *
 * Ref: audit-reports/feat-domain-mapping-audit/rapport.md F-3
 */
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUserPrimaryDomain(userOrgId: string | null | undefined) {
  return useQuery<string | null>({
    queryKey: ["user-primary-domain", userOrgId ?? "none"],
    queryFn: async () => {
      if (!userOrgId) return null;

      const { data, error } = await supabase
        .from("organization_domains_public" as any)
        .select("hostname")
        .eq("organization_id", userOrgId)
        .eq("is_primary", true)
        .eq("pattern_type", "exact") // F-3c: exkludera wildcard-rader (malformed redirect-URL annars)
        .maybeSingle();

      if (error) {
        console.error("[useUserPrimaryDomain] lookup failed:", error.message);
        return null;
      }
      return (data as { hostname: string } | null)?.hostname ?? null;
    },
    enabled: !!userOrgId,
    staleTime: Infinity,
    retry: 1,
  });
}
